// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/stores/index'
import axios from '@/axiosConnection'
import toastr from '@/toastr'
import i18n from '@/traductions/config'
// import {
//   defaultLocale
// } from '@/traductions/config'
import Paginate from 'vuejs-paginate'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Bootstrap Vue Initialization
Vue.use(BootstrapVue)
import {
  BPagination
} from 'bootstrap-vue'
import BTable from 'bootstrap-vue/es/components/table/table'
Vue.component('b-pagination', BPagination)

// b-table : textes vides en français par défaut (bootstrap-vue rc.13 n'a pas de config globale)
BTable.props.emptyText.default = 'Aucun élément à afficher'
BTable.props.emptyFilteredText.default = 'Aucun résultat ne correspond à votre recherche'

// Vue Select
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css';

// MomentJS Initialization
const moment = require('moment')
require('moment/locale/fr')
Vue.use(require('vue-moment'), {
  moment
})

// ProgressBar config
NProgress.configure({
  easing: 'ease',
  speed: 700
});

// Custom components creation
Vue.component('paginate', Paginate)

// Barcode
import VueBarcode from 'vue-barcode';
Vue.component('barcode', VueBarcode)

import BackLink from "@/components/Global/BackLink";
Vue.component('backlink', BackLink)

// Autocomplete employé : enregistré globalement car AdminTableSync le monte dynamiquement
// (<component :is>) pour les filtres étendus de type 'autocomplete'.
import EmployeeAutocomplete from "@/components/Global/EmployeeAutocomplete";
Vue.component('EmployeeAutocomplete', EmployeeAutocomplete)

// Autocomplete agence : même raison d'être, 644 agences à parcourir dans un <select>.
import AgencyAutocomplete from "@/components/Global/AgencyAutocomplete";
Vue.component('AgencyAutocomplete', AgencyAutocomplete)

// Autocomplete maintenance externe : même raison d'être, plus de 100 000 lignes en base.
import ExternalMaintenanceAutocomplete from "@/components/Global/ExternalMaintenanceAutocomplete";
Vue.component('ExternalMaintenanceAutocomplete', ExternalMaintenanceAutocomplete)

// Autocomplete générique : même raison d'être, mais sur une liste d'options déjà calculée
// par la vue (le demandeur d'une facture manuelle dépend de l'agence saisie).
import OptionsAutocomplete from "@/components/Global/OptionsAutocomplete";
Vue.component('OptionsAutocomplete', OptionsAutocomplete)

// QR-006 : viseur de scan par appareil photo, enregistré globalement car les cinq écrans
// mobiles de scan (préparation, retour, transfert, réception, recherche de référence) le
// posent tous à l'identique à côté de leur champ de scan.
import CameraScanner from "@/components/Global/CameraScanner";
Vue.component('CameraScanner', CameraScanner)

// QR-004 / QR-006 : sélecteur du mode de saisie (douchette, photo, saisie manuelle), posé
// au-dessus du champ sur ces mêmes écrans.
import ScanModeSwitch from "@/components/Global/ScanModeSwitch";
Vue.component('ScanModeSwitch', ScanModeSwitch)

import JsonCSV from 'vue-json-csv'
Vue.component('downloadCsv', JsonCSV)

import {
  default as exportPdfMixin
} from '@/mixins/exportPdf';

import {
  default as formatDatasMixin
} from '@/mixins/formatDatas';

import {
  default as authMixin
} from '@/mixins/auth';

// Filtre global, comme `moment` : un numéro de téléphone s'affiche en paires de chiffres
// partout où il apparaît, quelle que soit la façon dont il a été saisi.
import { formatPhone } from '@/filters/phone';
Vue.filter('phone', formatPhone);

// Totaux des listes : « 1 523 619 résultats » plutôt que « 1523619 ».
import { formatThousands } from '@/filters/number';
Vue.filter('thousands', formatThousands);


// Failure callback for axios interceptor
function errorResponseHandler(error) {
  NProgress.done();
  // Check for errorHandle config
  if (error.config.hasOwnProperty('errorHandle') && error.config.errorHandle === false) {
    return Promise.reject(error)
  }

  // Send notification depending on HTTP status, or if a status is given in datas
  if (error.response.data && error.response.data.status) {
    let object_type = router.currentRoute.fullPath.split('/')[1]
    toastr.error(i18n.t('error.' + object_type + '.' + error.response.data.status))
  } else if (error.response.status === 400) {
    toastr.error(i18n.t('http.bad_request'))
  } else if (error.response.status === 401) {
    return
  } else if (error.response.status === 403) {
    toastr.error(i18n.t('http.forbidden'))
  } else if (error.response.status === 404) {
    toastr.error(i18n.t('http.not_found'))
  }

  // Redirect depending on HTTP status, or push to the congifured path
  if (error.response.config.hasOwnProperty('redirectOnFailure')) {
    router.push(error.response.config.redirectOnFailure)
  } else if (error.response.status === 400) {
    router.back()
  } else if (error.response.status === 401) {
    router.push({
      name: 'Unauthorized'
    })
  } else if (error.response.status === 403) {
    router.push({
      name: 'UnauthorizedWithMessage',
      params: {
        message: error.response.data.status
      }
    })
  } else if (error.response.status === 404) {
    router.push({
      name: 'ErrorNotFound'
    })
  }

  return Promise.reject(error)
}

// Success callback for axios interceptor
function successResponseHandler(response) {
  NProgress.done();
  // Check for successHandle config
  if (response.config.hasOwnProperty('successHandle') && response.config.successHandle === false) {
    return Promise.resolve(response)
  }

  // If request success
  if ([200, 201].includes(response.status)) {
    if (response.data.status) {

      // Send a notification if a status is given in datas
      let object_type = router.currentRoute.fullPath.split('/')[1]

      // Push to the redirect path if congifured
      if (response.config.hasOwnProperty('redirectOnSuccess')) {
        router.push(response.config.redirectOnSuccess)
      }
    }
  }

  return Promise.resolve(response)
}

// before a request is made start the nprogress
axios.interceptors.request.use(config => {
  NProgress.start()
  return config
})

// Axios interceptor
axios.interceptors.response.use(
  successResponseHandler,
  errorResponseHandler
)

Array.prototype.selectOptions = function (key, val) {
  let newArray = [];

  this.forEach(element => {
    let text = ''
    if (Array.isArray(val)) {
      val.forEach(item => {
        let tmpText = resolve(element, item)
        text += tmpText || item
      })
    } else {
      text = resolve(element, val)
    }
    newArray.push({
      value: resolve(element, key),
      text: text
    })
  });
  return newArray

  function resolve(obj, path) {
    path = path.split(".");
    var current = obj;
    while (path.length) {
      if (typeof current !== "object") return undefined;
      current = current[path.shift()];
    }
    return current;
  }
}

String.prototype.toKebab = function () {
  return this.normalize('NFD')
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9 ]/g, "")
    .replace(/(?!^)([A-Z])/g, ' $1')
    .replace(/[_\s]+(?=[a-zA-Z])/g, '-').toLowerCase();
}

String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
}

String.prototype.replaceDotByComma = function () {
  return this.toString().replace(/\./, ',');
}

// Global vars
Vue.prototype.$http = axios
Vue.prototype.$toastr = toastr
Vue.config.productionTip = false

new Vue({
  el: '#app',
  store,
  router,
  i18n,
  components: {
    App
  },
  mixins: [
    exportPdfMixin,
    formatDatasMixin,
    authMixin
  ],
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js